<template>
    <div class="order-form__delivery-select row" v-if="deliveries">
        <div class="col-12">
            <span class="order-form__delivery-title">Выберите способ доставки:</span>
        </div>
        <div class="col-12">
            <div class="order-form__delivery-list">
                <div class="order-form__delivery-item" v-for="delivery in correctOrder" :key="delivery.ID">
                    <label
                        v-if="delivery.CALC"
                        class="order-form__delivery-option"
                        :class="{'active': deliveryID == delivery.ID}"
                        @click="setStartPayment"
                    >
                        <input
                            class="delivery-option__input visually-hidden"
                            type="radio"
                            name="DELIVERY_ID"
                            :value="delivery.ID"
                            @change="$emit('change', { price: delivery.CALC.PRICE_FORMATED, id: delivery.ID })"
                        >
                        <div class="delivery-option__name">
                            {{ delivery['OWN_NAME'] }}
                        </div>

                        <div class="delivery-option__price">
                            <template v-if="isOptionalPrice(delivery)">
                                <div class="delivery-option__price-current" v-html="delivery.CALC.DELIVERY_DISCOUNT_PRICE_FORMATED" />
                                <div class="delivery-option__price-old" v-html="delivery.CALC.PRICE_FORMATED" />
                            </template>
                            <template v-else>
                                <span v-html="delivery.CALC.PRICE_FORMATED" />
                            </template>
                        </div>

                        <div class="delivery-option__time" v-if="delivery.CALC.PERIOD_TEXT">
                            {{ delivery.CALC.PERIOD_TEXT }}
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'order-deliveries-buttons',

    props: {
        deliveries: {
            type: Array,
        },

        deliveryID: {
            type: String,
        },
    },
    data: function (){
      return {
          minPriceDeliveryID: null,
          sortedDeliveries: [],
      }
    },

    computed: {
        correctOrder() {
            return this.sortedDeliveries;
        },
    },
    created() {
        this.sortedDeliveries = this.deliveries.sort(function (a, b){
            if (a.CALC.PRICE > b.CALC.PRICE) return 1; // если первое значение больше второго
            if (a.CALC.PRICE === b.CALC.PRICE) return 0; // если равны
            if (a.CALC.PRICE < b.CALC.PRICE) return -1; // если первое значение меньше второго
        });
        this.minPriceDeliveryID = this.sortedDeliveries[0].CALC.ID
    },
    methods: {
        isOptionalPrice(delivery) {
            return delivery?.CALC?.DELIVERY_DISCOUNT_PRICE_FORMATED;
        },
        setStartPayment() {
            console.log('dk')
            $('#cardPayment').trigger('click');
        },
    },
};
</script>
